import {TREE} from './globals'
import * as storage from './storage'

export interface RecentBook {
  urlId: string
  title: string
}

const RECENT_KEY = `${TREE}reader/recent`
const RECENT_MAX = 5

export function getRecentBooks(): RecentBook[] {
  const raw = storage.get(RECENT_KEY)
  if (!raw) return []
  try {
    return JSON.parse(raw) as RecentBook[]
  } catch {
    return []
  }
}

export function addRecentBook(book: RecentBook): void {
  const current = getRecentBooks()
  const updated = [
    book,
    ...current.filter(b => b.urlId !== book.urlId),
  ].slice(0, RECENT_MAX)
  storage.put(RECENT_KEY, JSON.stringify(updated))
}
